// user.stats.dto.ts (à créer dans le même dossier)
import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const userStatsSchema = z.object({
  total: z.number(),
  newUsers: z.number(),
  active: z.number(),
  banned: z.number(),
  verified: z.number(),
  verificationRate: z.number().min(0).max(100),
});

export class UserStatsDto extends createZodDto(userStatsSchema) {}

export const topUserByResumesSchema = z.array(
  z.object({
    userId: z.string(),
    name: z.string(),
    count: z.number(),
  }),
);

export class TopUserByResumesDto extends createZodDto(topUserByResumesSchema) {}
